
import datatables from 'linksoft-datatables';

export default function () {

    datatables.addCallbacks({
	});
}


// WEBPACK FOOTER //
// ./App/config/table-callbacks.js